import { Text } from "@/components/ui/text";
import i18n from "i18n-js";
import React from "react";
import BasicButton from "@/components/basic/BasicButton";
import ModalBase from '@/components/basic/ModalBase';

export default function ModalStepType({ showModal, setShowModal, name, updateType }) {

    return (
        <ModalBase showModal={showModal}>
            <Text bold className="text-2xl text-secondary-900 bg-secondary-50">{i18n.t('stepType.title')}</Text>
            <BasicButton onPress={() => { updateType(0); setShowModal(false) }} text={i18n.t('stepType.do')} />
            <BasicButton onPress={() => { updateType(1); setShowModal(false) }} text={i18n.t('stepType.fetch')} />
            <BasicButton onPress={() => { updateType(2); setShowModal(false) }} text={i18n.t('stepType.wait')} />
            {name == 'StdEdit' && <BasicButton onPress={() => { updateType(3); setShowModal(false) }} text={i18n.t('stepType.decide')} />}
        </ModalBase>
    );
}
